module.exports = __webpack_public_path__ + "static/home-main-20220215-d6897791bfea13806a9bb1a29b981f39.svg";